import React, { ReactElement } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { selectAlertProps, selectOpen, setOpen, selectIsError } from "./globalSnackbarSlice";
import { Alert, Snackbar, SnackbarCloseReason, useTheme } from "@mui/material";
import { MailOutline } from "@mui/icons-material";

export default function GlobalSnackbar(): ReactElement {
  const theme = useTheme();
  const dispatch = useAppDispatch();
  const isOpen = useAppSelector(selectOpen);
  const alertProps = useAppSelector(selectAlertProps);
  const isError = useAppSelector(selectIsError);

  const handleClose = (event: Event | React.SyntheticEvent<any, Event>, reason?: SnackbarCloseReason) => {
    if (reason === "clickaway") {
      return;
    }
    dispatch(setOpen(false));
  };

  const mailDestination = import.meta.env.VITE_BTC_MAIL;
  const sendEmailHandler = () => {
    //eslint-disable-next-line scanjs-rules/assign_to_href
    window.location.href = `mailto:${mailDestination}?subject=Fehler in Anwendung PowerQuality&body=
    Uhrzeit: ${alertProps.dateAndTime} %0D%0A
    Status Code: ${alertProps.statusCode} %0D%0A
    Request ID: ${alertProps.xRequestID} %0D%0A
    Request Url: ${alertProps.requestUrl}`;
  };

  return (
    <Snackbar
      open={isOpen}
      autoHideDuration={alertProps.duration}
      onClose={handleClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <Alert onClose={handleClose} severity={alertProps.severity}>
        <b>{alertProps.title}</b>
        {alertProps.message}
        {isError ? (
          <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
            {" "}
            <div
              style={{
                borderColor: theme.palette.grey[200],
                width: "fit-content",
                display: "flex",
                alignItems: "center",
                fontSize: "14px",
                justifyContent: "center",
                cursor: "pointer",
                lineHeight: "20px",
              }}
              onClick={sendEmailHandler}
            >
              <MailOutline style={{ height: "16px", width: "16px", marginRight: "12px" }} />
              Ticket beim Service Desk eröffnen
            </div>
          </div>
        ) : (
          ""
        )}
      </Alert>
    </Snackbar>
  );
}
